import React from "react";
import { withTheme } from "styled-components";
import { FormattedMessage } from "@irati/utils/lang";
import { getQuery } from "@irati/utils/history";
import { Body, H2 } from "@irati/ui/src/Typography";
import { Banner } from "@irati/ui/src/Layout";
import image from "@irati/ui/images/success.svg";
import LoginBlock from "../LoginBlock";
import { Img, StyledCard } from "./styled";
var CheckEmail = function (_a) {
    var theme = _a.theme;
    return (React.createElement(React.Fragment, null,
        React.createElement(Banner, null),
        React.createElement(LoginBlock, null,
            React.createElement(StyledCard, null,
                React.createElement(Img, { src: image, alt: "Check Email" }),
                React.createElement(H2, { padding: theme.spacing.one + " 0 " + theme.spacing.four },
                    React.createElement(TitleText, null)),
                React.createElement(Body, null,
                    React.createElement(BodyText, null))))));
};
var TitleText = function () {
    if (getQuery().subdomain) {
        return React.createElement(FormattedMessage, { id: "platform.checkEmail.header.forgotSubdomain" });
    }
    return React.createElement(FormattedMessage, { id: "platform.checkEmail.header.passwordReset" });
};
var BodyText = function () {
    if (getQuery().subdomain) {
        return React.createElement(FormattedMessage, { id: "platform.checkEmail.subdomain.body" });
    }
    return React.createElement(FormattedMessage, { id: "platform.checkEmail.body" });
};
export default withTheme(CheckEmail);
